/// <amd-module name="Wit/BacklogsHub/Common/Services/BacklogsHubHeaderService" />
import { IObservableArray, ObservableArray } from "VSS/Core/Observable";
import { IVssPageContext, IVssService, Services, VssService } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { DataProviders } from "Wit/BacklogsHub/Common/BacklogHubContants";
import { BacklogLevelConfiguration } from "Wit/Clients/Work/Contracts/Work";
import { ExceptionInfo } from "Wit/Common/HubError/Models/Models";

// TODO: move to genclient
interface IBacklogsHubContentHeaderData {
    allBacklogLevels: BacklogLevelConfiguration[];
    backlogId: string;
    exceptionInfo: ExceptionInfo;
    hasIterations: boolean;
    newBacklogLevelsSignature: string;
    requirementLevelName: string;
    teamId: string;
    teamName: string;
    visibleBacklogLevels: BacklogLevelConfiguration[];
}

// TODO: move to genclient
export interface IBacklogColumn {
    columnReferenceName: string;
    notAField: boolean;
    rollup: boolean;
    rollupCalculation: IRollupCalculation;
    width: number;
}

// TODO: move to genclient
export interface IRollupCalculation {
    aggregation: RollupAggregation;
    aggregationField: string;
    backlogFilter: string;
    type: RollupType;
    workItemTypeFilter: string;
}

// TODO: move to genclient
export enum RollupAggregation {
    Count = 0,
    Sum = 1
}

// TODO: move to genclient
export enum RollupType {
    Progress = 0,
    Total = 1
}

export interface IBacklogsHubHeaderService extends IVssService {
    getVisibleBacklogLevels(): IObservableArray<BacklogLevelConfiguration>;
    getAllBacklogLevels(): Promise<BacklogLevelConfiguration[]>;
    getHeaderError(): Promise<ExceptionInfo | undefined>;
    updateVisibleBacklogLevels(): Promise<void>;
}

export class BacklogsHubHeaderService extends VssService implements IBacklogsHubHeaderService {
    private headerData: IBacklogsHubContentHeaderData | undefined;
    private visibleBacklogLevels: ObservableArray<BacklogLevelConfiguration> = new ObservableArray([]);

    public _serviceStart = (pageContext: IVssPageContext): void => {
        super._serviceStart(pageContext);
    };

    public _serviceEnd = (pageContext: IVssPageContext): void => {
        super._serviceEnd(pageContext);
    };

    public getAllBacklogLevels = async (): Promise<BacklogLevelConfiguration[]> => {
        const data = await this.ensureData();
        return data?.allBacklogLevels || [];
    };

    public getTeamId = async (): Promise<string> => {
        const data = await this.ensureData();
        return data?.teamId || "";
    };

    public getTeamName = async (): Promise<string> => {
        const data = await this.ensureData();
        return data?.teamName || "";
    };

    public getVisibleBacklogLevels = (): IObservableArray<BacklogLevelConfiguration> => {
        return this.visibleBacklogLevels;
    };

    public updateVisibleBacklogLevels = async (): Promise<void> => {
        await this.ensureData({ ignoreCache: true });
    };

    public getHeaderError = async (): Promise<ExceptionInfo | undefined> => {
        const data = await this.ensureData();
        return data?.exceptionInfo;
    };

    private async ensureData(options?: { ignoreCache: boolean }): Promise<IBacklogsHubContentHeaderData | undefined> {
        if (!this.headerData || (options && options.ignoreCache)) {
            const contributionService = this.pageContext.getService<IVssContributionService>("IVssContributionService");

            this.headerData = await contributionService.getDataAsync<IBacklogsHubContentHeaderData>(
                DataProviders.BacklogsHubContentHeaderDataProvider
            );
        }

        if (this.headerData?.visibleBacklogLevels) {
            this.visibleBacklogLevels.value = this.headerData.visibleBacklogLevels;
        } else {
            this.visibleBacklogLevels.value = [];
        }

        return this.headerData;
    }
}

Services.add("IBacklogsHubHeaderService", { serviceFactory: BacklogsHubHeaderService });
